/* RESPONSIBLE TEAM: team-messenger */
import { helper as buildHelper } from '@ember/component/helper';

export function lowercaseFirst(params: [string?]) {
  let text = params[0] || '';
  if (text.length === 0) {
    return '';
  }
  return text.charAt(0).toLowerCase() + text.slice(1);
}

let helper = buildHelper<{
  Args: {
    Positional: [string];
  };
  Return: string;
}>(lowercaseFirst);

export default helper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'lowercase-first': typeof helper;
  }
}
